import axios from "axios";
import {
  GET_NEWSS,
  ADD_NEWS,
  UPDATE_NEWS,
  DELETE_NEWS,
  ERROR_NEWS,
  UPLOAD_PROGRESS,
  REMOVE_PROGRESS,
} from "./types";

// GET CONFERANCES
export const getNews = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/news");
    dispatch({
      type: GET_NEWSS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: ERROR_NEWS,
      payload: { msg: error.response, status: error.response },
    });
  }
};

export const addNews = (file, title, description) => async (dispatch) => {
  const formData = new FormData();
  for (let i = 0; i < file.length; i++) {
    formData.append("newsImage", file[i]);
  }
  formData.append("title", title);
  formData.append("discription", description);
  try {
    const options = {
      onUploadProgress: (ProgressEvent) => {
        const { loaded, total } = ProgressEvent;
        let percent = Math.floor((loaded * 100) / total);
        console.log(`${loaded}kb of ${total}kb | ${percent}% `);
        dispatch({
          type: UPLOAD_PROGRESS,
          payload: { loaded, total, percent },
        });
        if (percent === 100) {
          setTimeout(() => dispatch({ type: REMOVE_PROGRESS }), 5000);
        }
      },
    };
    const res = await axios.post("/api/news", formData, options);
    dispatch({
      type: ADD_NEWS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: ERROR_NEWS,
      payload: {
        msg: error.response.statusText,
        status: error.response.status,
      },
    });
  }
};

export const updateNews = (formData) => async (dispatch) => {
  const config = { headers: { "Content-Type": "application/json" } };
  try {
    const res = await axios.put(`/api/news/${formData.id}`, formData, config);
    dispatch({
      type: UPDATE_NEWS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: ERROR_NEWS,
      payload: {
        msg: error.response.statusText,
        status: error.response.status,
      },
    });
  }
};

export const deleteNews = (id) => async (dispatch) => {
  try {
    // eslint-disable-next-line
    const res = await axios.delete(`/api/news/${id}`);
    dispatch({
      type: DELETE_NEWS,
      payload: id,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: ERROR_NEWS,
      payload: {
        msg: error.response.statusText,
        status: error.response.status,
      },
    });
  }
};
